module.exports = __webpack_public_path__ + "img/parkOperation.948cf19a.svg";